import { Fragment } from "react";
import { withRouter } from "react-router-dom";

import { ArrowCircleLeft } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";

import AppBarIconButton from "./appBarIconButton";

const PortalBackNav = props => {
  const handleBackNav = () => {
    props.history.push("/");
  };
  const theme = useTheme();

  return (
    <Fragment>
      <Tooltip title="Go back home..." placement="right-start">
        <AppBarIconButton
          size="large"
          edge="start"
          // color="inherit"
          color="primary"
          id="omni-primary-menu-button"
          onClick={e => {
            e.stopPropagation();
            handleBackNav();
          }}
        >
          <Avatar
            fontSize="large"
            alt={"?"}
            sx={{
              background: theme.palette.primary.contrastText,
            }}
          >
            <ArrowCircleLeft
              sx={{
                size: "large",
                width: 40,
                height: 40,
                color: theme.palette.secondary.main,
              }}
            />
          </Avatar>
        </AppBarIconButton>
      </Tooltip>
    </Fragment>
  );
};

export default withRouter(PortalBackNav);
